let product_grid = document.querySelectorAll('.grid__item');
product_grid.forEach(function(item) {
  item.addEventListener("click", function () {
    let body = document.querySelector('body');
    let page_name = body ? body.getAttribute('data-template') : null;
    console.log(page_name);
    sessionStorage.setItem("page_name", page_name);
  });
});

if(window.location.href.indexOf('/product') > -1){
  let page_name =  sessionStorage.getItem("page_name");
    if(page_name == 'index'){
        
    }else{
      if(document.querySelector('.home_link')){
        document.querySelector('.home_link').style.display = 'none';  
      }
     
    }
} 